export interface ImageCardSettings {
  showBackground?: boolean;
  backgroundColor?: string;
  imageDataUrl?: string;
  cardStyles: Partial<CSSStyleDeclaration>;
  position?: {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
  };
}

export const defaultImageCardStyles: Partial<CSSStyleDeclaration> = {
  backgroundColor: '#FEFEFE',
  opacity: '1',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
